import React from 'react';

const ArbitrumBadge = ({ className = "w-16 h-16", animated = true }) => {
  return (
    <svg 
      className={`${className} ${animated ? 'animate-spin' : ''}`}
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{animationDuration: '10s'}}
    >
      <defs>
        <linearGradient id="arbitrumGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2D374B" />
          <stop offset="50%" stopColor="#28A0F0" />
          <stop offset="100%" stopColor="#96BEDC" />
        </linearGradient>
        <filter id="arbitrumGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Outer Ring */}
      <circle 
        cx="50" 
        cy="50" 
        r="45" 
        fill="none" 
        stroke="url(#arbitrumGradient)" 
        strokeWidth="3" 
        filter="url(#arbitrumGlow)"
        className="transition-all duration-300 hover:scale-110"
      />
      
      {/* Inner Hexagon */}
      <polygon 
        points="50,15 70,30 70,55 50,70 30,55 30,30" 
        fill="url(#arbitrumGradient)" 
        filter="url(#arbitrumGlow)"
        className="transition-all duration-300 hover:scale-110"
      />
      
      {/* Center Circle */}
      <circle 
        cx="50" 
        cy="50" 
        r="20" 
        fill="#1F2937" 
        stroke="#28A0F0" 
        strokeWidth="2"
        className="transition-all duration-300 hover:scale-110"
      />
      
      {/* Arbitrum "A" */}
      <text 
        x="50" 
        y="58" 
        textAnchor="middle" 
        className="fill-white font-bold text-lg"
        style={{fontFamily: 'Arial, sans-serif'}}
      >
        A
      </text>
      
      {/* Floating Particles */}
      <circle cx="20" cy="20" r="2" fill="#28A0F0" className="animate-ping" />
      <circle cx="80" cy="25" r="2" fill="#96BEDC" className="animate-ping" style={{animationDelay: '0.5s'}} />
      <circle cx="15" cy="80" r="2" fill="#2D374B" className="animate-ping" style={{animationDelay: '1s'}} />
      <circle cx="85" cy="75" r="2" fill="#28A0F0" className="animate-ping" style={{animationDelay: '1.5s'}} />
    </svg>
  );
};

export default ArbitrumBadge;
